import ReceiptIcon from "@material-ui/icons/Receipt";

import { CustomerArticlesList } from "./List/List";
import { CustomerArticlesShow } from "./Show/Show";

export { CustomerArticlesList, CustomerArticlesShow };

export const customerArticlesResource = {
	list: CustomerArticlesList,
	show: CustomerArticlesShow,
	create: null,
	edit: null,
	icon: ReceiptIcon,
};
